import { MouseEventHandler } from 'react';
import classNames from 'classnames';

import { PriceImpact } from 'types/Price';
import { OptionStatus } from 'types/ProductOptionGroup';
import { useOptionInfo } from '@templates/product/Options/components/OptionGroup/utils/optionInfo';
import SelectorOption from '@components/SelectorOption';
import { useIntl } from 'utils/intl';

import classes from './Option.module.scss';
import messages from './Option.messages';

const optionStatus = {
  active: 'active',
  soon: 'soon',
  inactive: 'inactive',
};

type Props = {
  name: string;
  priceImpact?: PriceImpact;
  status: OptionStatus;
  isSelected: boolean;
  isPredictionActive: boolean;
  isFadedOut: boolean;
  hideInfo: boolean;
  onHoverIn: () => void;
  onHoverOut: () => void;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const Option = ({
  name,
  priceImpact,
  isSelected,
  isPredictionActive,
  isFadedOut,
  hideInfo,
  status,
  onHoverIn,
  onHoverOut,
  onClick,
}: Props): JSX.Element => {
  const renderOptionInfo = useOptionInfo();
  const optionInfo = renderOptionInfo(status, priceImpact);
  const intl = useIntl();

  return (
    <SelectorOption
      className={classes.wrapper}
      isSelected={isSelected}
      isPredictionActive={isPredictionActive}
      isFadedOut={isFadedOut}
      status={status}
      onClick={onClick}
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
    >
      <div className={classes.name}>{name || intl.formatMessage(messages.noneValue)}</div>

      {!isSelected && optionInfo && (
        <div className={classNames(classes.info, { [classes.hideInfo]: hideInfo })}>{optionInfo}</div>
      )}
    </SelectorOption>
  );
};

Option.status = optionStatus;

export default Option;
